require('./helpers/bundle-manifest').register(JSON.parse("{\"2lyl3\":\"index.f1a0a25d.js\",\"aI9vf\":\"sw.0cb39ff7.png\"}"));